<template>
  <button  class="dont-print" @click="exportToExcel()">📊Export to Excel</button>
</template>

<script>
export default {
  name: 'ExportToExcel',
  inject: ['page'],
  props:[
    'storeName',
    'tables',
    'sheetNames',
    'bookName',
    'day',
    'month',
    'timestamps',
    'from',
    'to',
    'dateFormat',
  ],
  computed:{
    store(){return this.page ? this.page.$refs[this.storeName] : undefined},
    _bookName(){
      let bookName = ''

      if(this.store){
        const from = moment(this.store.timestamps.from).format('YYMMDD')
        const to = moment(this.store.timestamps.to).format('YYMMDD')
        bookName = `${from}-${to} `
      }
      if(this.timestamps){
        const from = moment(this.timestamps.from).format('YYMMDD')
        const to = moment(this.timestamps.to).format('YYMMDD')
        bookName = `${from}-${to} `
      }
      if(this.from && this.to){
        const from = moment(this.from).format('YYMMDD')
        const to = moment(this.to).format('YYMMDD')
        bookName = `${from}-${to} `
      }
      if(this.month){
        bookName = `${moment(this.month).format('YYMM')} `
      }
      if(this.day){
        bookName = `${moment(this.day).format('YYMMDD')} `
      }
      if(this.bookName){
        bookName += this.bookName
        bookName = bookName.endsWith('.xls') ? bookName : bookName + '.xls'
      } else {
        bookName += 'Workbook.xls'
      }
      return bookName;
    }
  },
  methods:{
    exportToExcel(){
      const options = {DateFormat: this.dateFormat}
      console.log('DEBUG ExportToExcel', options)
      this.$table2excel.downloadTable(this.tables, this.sheetNames ? this.sheetNames : this.tables, this._bookName, options)
    }
  }
}
</script>